export const GTMOriginalEvents = {
  EcommerceImpressionView: 'ecommerceImpressionView',
  EcommerceImpressionClick: 'ecommerceImpressionClick',
  EcommerceDetail: 'ecommerceDetail',
  EcommerceCheckout: 'ecommerceCheckout',
  EcommerceCheckoutOption: 'ecommerceCheckoutOption',
  EcommercePurchase: 'ecommercePurchase',
  AuthOpen: 'authOpen',
  AuthClose: 'authClose',
  AuthComplete: 'authComplete',
  AuthLoginSuccess: 'authLoginSuccess',
  AuthLoginFail: 'authLoginFail',
  AuthSignupSuccess: 'authSignupSuccess',
  AuthSignupFail: 'authSignupFail',
};

export const GTMEvents = {
  ViewedExperiences: 'viewedExperiences',
  ClickOnExperience: 'clickOnExperience',
  ViewExperiencePage: 'viewExperiencePage',
  CheckoutStep1Init: 'checkoutStep1Init',
  CheckoutStep1: 'checkoutStep1',
  CheckoutStep2Init: 'checkoutStep2Init',
  CheckoutStep2: 'checkoutStep2',
  CheckoutStep3Init: 'checkoutStep3Init',
  CheckoutStep3: 'checkoutStep3',
  CheckoutStep4Init: 'checkoutStep4Init',
  Purchase: 'purchase',
  AuthOpen: 'authOpen',
  AuthClose: 'authClose',
  AuthComplete: 'authComplete',
  AuthLoginSuccess: 'authLoginSuccess',
  AuthLoginFail: 'authLoginFail',
  AuthSignupSuccess: 'authSignupSuccess',
  AuthSignupFail: 'authSignupFail',
};

export const GTMList = {
  Home: 'Home',
  Market: 'Market',
  Filtered: 'Filtered',
  Related: 'Related',
  Kiosk: 'Kiosk',
};

export const GTMBookingStep = {
  DateAndTime: 1,
  Authenticate: 2,
  Guests: 3,
  Payment: 4,
};

export const GTMActions = {
  LoggedIn: 'loggedIn',
  LogIn: 'logIn',
  SignUp: 'signUp',
};

export const IntercomEvents = {
  ExperienceView: 'experienceView',
  CheckoutDatesAndTimes: 'checkoutDatesAndTimes',
  CheckoutAuthenticate: 'checkoutAuthenticate',
  CheckoutGuests: 'checkoutGuests',
  CheckoutPayment: 'checkoutPayment',
  PurchaseComplete: 'purchaseComplete',
};

export const IntercomBookingStep = {
  DateAndTime: 1,
  Authenticate: 2,
  Guests: 3,
  Payment: 4,
};
